(function () {
  'use strict';

  angular
    .module('app.mini-cart', [])

    .directive('miniCart', function () {
      return {
        restrict: 'E',
        /* @ngInject */
        controller: ["$scope", "$element", "AppService", "RoutesService", "ModalService", function ($scope, $element, AppService, RoutesService, ModalService) {
          var ctrl = this;

          // Translate
          var tplTranslate = {};
          $element.children('.translate').children().each(function () {
            var $this = $(this);
            tplTranslate[$this.attr('key')] = $this.html();
          });

          getCart();

          ctrl.emptyCart = function () {
            ModalService.show(
              '/Template/Cart/ModalClearCartConfirm',
              {},
              null,
              'clearCartConfirmModalCtrl'
            );
          };

          ctrl.remove = function (line) {
            ModalService.show(
              '/Template/Cart/ModalDeleteConfirm',
              {
                action: function () {
                  AppService.deleteLine(line.IDLine, line.Product.Designation, line.Product.IDPicture, tplTranslate.titleDeleteOk);
                }
              },
              null,
              'deleteConfirmModalCtrl'
            );
          };

          $scope.$on('cartUpdate', function () {
            getCart();
          });

          function getCart() {
            AppService.getParams()
              .then(function (data) {
                ctrl.hasCart = data.HasCart;
                ctrl.cartLink = !ctrl.hasCart ? '' : '/' + RoutesService.getUrlByName('Cart');
                ctrl.count = 0;
                if (ctrl.hasCart) {
                  ctrl.data = data.Cart;
                  var count = 0;
                  _.each(ctrl.data.Products, function (line) {
                    count += line.Quantity;
                  });
                  ctrl.count = count;
                }
              })
              .catch(function (error) {
                console.error(error);
              });
          }
        }],
        controllerAs: 'miniCartCtrl'
      };
    });

})();
